// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
=============== 
Slider
===============
*/

.title {
    text-align: center;
    margin-bottom: 2rem;
}

.title h2 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
}

.title span {
    font-size: 0.85em;
    color: var(--clr-primary-5);
    margin-right: 1rem;
    font-weight: 700;
}

.section-center.slider {
    margin: 0 auto;
    margin-top: 4rem;
    width: 80vw;
    height: 450px;
    max-width: 800px;
    text-align: center;
    position: relative;
    display: flex;
    overflow: hidden;
}

.person-img.slider {
    border-radius: 50%;
    margin-bottom: 1rem;
    width: 150px;
    height: 150px;
    object-fit: cover;
    border: 4px solid var(--clr-grey-8);
    box-shadow: var(--dark-shadow);
}

slidearticle h4 {
    text-transform: uppercase;
    color: var(--clr-primary-5);
    margin-bottom: 0.25rem;
}

.title {
    text-transform: capitalize;
    margin-bottom: 0.75rem;
    color: var(--clr-grey-3);
}

.text {
    max-width: 35em;
    margin: 0 auto;
    margin-top: 2rem;
    line-height: 2;
    color: var(--clr-grey-5);
}

.icon {
    font-size: 3rem;
    margin-top: 1rem;
    color: var(--clr-primary-5);
}

.prev,
.next {
    position: absolute;
    top: 200px;
    transform: translateY(-50%);
    background: var(--clr-grey-5);
    color: var(--clr-white);
    width: 1.25rem;
    height: 1.25rem;
    display: grid;
    place-items: center;
    border-color: transparent;
    font-size: 1rem;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
}

.prev:hover,
.next:hover {
    background: var(--clr-primary-5);
}

.prev {
    left: 0;
}

.next {
    right: 0;
}

@media (min-width: 800px) {
    .text {
        max-width: 45em;
    }
    .prev,
    .next {
        width: 2rem;
        height: 2rem;
        font-size: 1.5rem;
    }
}

slidearticle {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: var(--transition);
}

slidearticle.activeSlide {
    opacity: 1;
    transform: translateX(0);
}

slidearticle.lastSlide {
    transform: translateX(-100%);
}

slidearticle.nextSlide {
    transform: translateX(100%);
}`, "",{"version":3,"sources":["webpack://./src/slider/slider.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;AACjC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;;QAEI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["/*\r\n=============== \r\nSlider\r\n===============\r\n*/\r\n\r\n.title {\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.title h2 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: 500;\r\n}\r\n\r\n.title span {\r\n    font-size: 0.85em;\r\n    color: var(--clr-primary-5);\r\n    margin-right: 1rem;\r\n    font-weight: 700;\r\n}\r\n\r\n.section-center.slider {\r\n    margin: 0 auto;\r\n    margin-top: 4rem;\r\n    width: 80vw;\r\n    height: 450px;\r\n    max-width: 800px;\r\n    text-align: center;\r\n    position: relative;\r\n    display: flex;\r\n    overflow: hidden;\r\n}\r\n\r\n.person-img.slider {\r\n    border-radius: 50%;\r\n    margin-bottom: 1rem;\r\n    width: 150px;\r\n    height: 150px;\r\n    object-fit: cover;\r\n    border: 4px solid var(--clr-grey-8);\r\n    box-shadow: var(--dark-shadow);\r\n}\r\n\r\nslidearticle h4 {\r\n    text-transform: uppercase;\r\n    color: var(--clr-primary-5);\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n.title {\r\n    text-transform: capitalize;\r\n    margin-bottom: 0.75rem;\r\n    color: var(--clr-grey-3);\r\n}\r\n\r\n.text {\r\n    max-width: 35em;\r\n    margin: 0 auto;\r\n    margin-top: 2rem;\r\n    line-height: 2;\r\n    color: var(--clr-grey-5);\r\n}\r\n\r\n.icon {\r\n    font-size: 3rem;\r\n    margin-top: 1rem;\r\n    color: var(--clr-primary-5);\r\n}\r\n\r\n.prev,\r\n.next {\r\n    position: absolute;\r\n    top: 200px;\r\n    transform: translateY(-50%);\r\n    background: var(--clr-grey-5);\r\n    color: var(--clr-white);\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n    display: grid;\r\n    place-items: center;\r\n    border-color: transparent;\r\n    font-size: 1rem;\r\n    border-radius: var(--radius);\r\n    cursor: pointer;\r\n    transition: var(--transition);\r\n}\r\n\r\n.prev:hover,\r\n.next:hover {\r\n    background: var(--clr-primary-5);\r\n}\r\n\r\n.prev {\r\n    left: 0;\r\n}\r\n\r\n.next {\r\n    right: 0;\r\n}\r\n\r\n@media (min-width: 800px) {\r\n    .text {\r\n        max-width: 45em;\r\n    }\r\n    .prev,\r\n    .next {\r\n        width: 2rem;\r\n        height: 2rem;\r\n        font-size: 1.5rem;\r\n    }\r\n}\r\n\r\nslidearticle {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    opacity: 0;\r\n    transition: var(--transition);\r\n}\r\n\r\nslidearticle.activeSlide {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n}\r\n\r\nslidearticle.lastSlide {\r\n    transform: translateX(-100%);\r\n}\r\n\r\nslidearticle.nextSlide {\r\n    transform: translateX(100%);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
